import {DateFormatter, Regex} from "@/helpers"

export default {
  data() {
    return {
      selectedItem: null,
      exportModalVisible: false,
      export_data: [],
      export_transaction_type: 'PAYIN',
      export_transaction_status: 'SUCCESS',
      export_from_datetime: DateFormatter.todayStart(),
      export_to_datetime: DateFormatter.todayEnd(),
      export_format: 'CSV',
      export_delimiter: ';',
      export_filename: '',
    }
  },
  computed: {
    exportFormatOptions() {
      return [{text: 'CSV', value: 'CSV'}]
    },
    exportDelimiterOptions() {
      return [{text: ';', value: ';'}, {text: ',', value: ','}]
    },
    exportTransactionTypeOptions() {
      return [{text: 'Paiements entrants', value: 'PAYIN'}, {text: 'Paiements sortants', value: 'PAYOUT'}]
    },
    exportTransactionStatusOptions() {
      return [
        {text: 'Tous les statuts', value: 'ALL'},
        {text: 'Transactions réussies', value: 'SUCCESS'},
        {text: 'Transactions échoués', value: 'FAILED'}
      ]
    },
    export_from_datetime_state() {
      return !this.submitted || Regex.isDatetime(this.export_from_datetime)
    },
    export_to_datetime_state() {
      return !this.submitted || Regex.isDatetime(this.export_to_datetime)
    },
    export_filename_state() {
      return !this.submitted || Regex.isValidFilename(this.export_filename)
    },
    export_extension() {
      return '.csv'
    },
  },
  methods: {
    onItemExport(item) {
      this.selectedItem = item
      this.export_filename = `My-CoolPay_Dump_${item.name.replace(/\W+/g, '-')}_${DateFormatter.raw()}`
      this.exportModalVisible = true
    },
    clearExportFields() {
      this.export_data = []
      this.export_transaction_type = 'PAYIN'
      this.export_transaction_status = 'SUCCESS'
      this.export_from_datetime = DateFormatter.todayStart()
      this.export_to_datetime = DateFormatter.todayEnd()
      this.export_format = 'CSV'
      this.export_delimiter = ';'
      this.export_filename = ''
    },
    onExportModalClose() {
      this.exportModalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.clearExportFields()
    },
    isExportFormValid() {
      return this.export_from_datetime_state && this.export_to_datetime_state && this.export_filename_state
    },
  },
}
